import { Dash } from './Dash';
import { DriveCycles } from './DriveCycles';
import { ODBCheck } from './OBDCheck';
import { UnderHood } from './UnderHood';

export const Mechanical = () => {
  return (
    <>
      <UnderHood />
      <ODBCheck />
      <Dash />
      <DriveCycles />
    </>
  );
};
